import { Component, Input, OnInit, forwardRef, OnDestroy, ChangeDetectorRef } from '@angular/core';

import {
  AbstractControl,
  ControlValueAccessor,
  FormBuilder,
  FormGroup,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ReactiveFormsModule,
  ValidationErrors,
  Validator,
  Validators
} from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { Subject, takeUntil } from 'rxjs';
import { PertinenceExistenceFormValue } from '@models/api/requests';
import { noWhitespaceValidator } from 'src/app/shared/utils/no-whitespace-validator';

@Component({
    selector: 'app-pertinence-existence-form',
    imports: [ReactiveFormsModule, MatFormFieldModule, MatInputModule],
    templateUrl: './pertinence-existence-form.component.html',
    styleUrls: ['./pertinence-existence-form.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => PertinenceExistenceFormComponent),
            multi: true
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => PertinenceExistenceFormComponent),
            multi: true
        }
    ]
})
export class PertinenceExistenceFormComponent implements OnInit, ControlValueAccessor, OnDestroy, Validator {
  @Input() readOnly = false;

  form: FormGroup;
  nbreCaratereTextarea1: string = "Votre texte ne doit pas dépasser 350 caractères."
  nbreCaratereTextarea2: string = "Votre texte ne doit pas dépasser 720 caractères."

  private readonly destroy$ = new Subject<void>();
  private onChange: (value: PertinenceExistenceFormValue) => void = () => { };
  private onTouched: () => void = () => { };

  constructor(
    private readonly fb: FormBuilder,
    private readonly cdr: ChangeDetectorRef
  ) {
    this.form = this.fb.group({
      pertinenceMission: [null, [Validators.required, Validators.maxLength(350), noWhitespaceValidator]],
      renouvellementAJustifier: [null, [Validators.required, Validators.maxLength(720), noWhitespaceValidator]]
    });
  }

  ngOnInit(): void {
    // Subscribe to form value changes to notify parent
    this.form.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((value) => {
      this.onChange(value);
      this.onTouched();
    });
  }

  // ControlValueAccessor methods
  writeValue(value: PertinenceExistenceFormValue): void {
    if (value) {
      this.form.patchValue(value, { emitEvent: false });
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  validate(control: AbstractControl): ValidationErrors | null {
    return this.form.valid ? null : { invalidPertinenceExistenceData: true };
  }

  setDisabledState(isDisabled: boolean): void {
    isDisabled ? this.form.disable({ emitEvent: false }) : this.form.enable({ emitEvent: false });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
